export { default, validateGreaterThanOrEqualToZero } from './validate'



/** WEBPACK FOOTER **
 ** ./src/utils/validate/index.js
 **/